<!--
 * @Date: 2025-04-02 16:01:12
 * @LastEditors: 'lidianbin' 'lidianbin@coocaa.com'
 * @LastEditTime: 2025-04-10 10:20:37
 * @FilePath: \ccms\packages\cms-engine\lib\render\TextEdit.vue
-->
<!-- 文本切换展示与编辑操作组件 -->
<template>
  <div class="cms-common-text-edit">
    <template v-if="mode">
      <span
        class="cms-common-edit-input"
        :class="{ 'input-hight': highlight }"
        contenteditable
        :data-content="value"
        @focus="highlight = true"
        @blur="handleEditEmit"
      >{{ value }}</span>
    </template>
    <span
      v-else
      @click.prevent="openLink"
      :class="{ 'cms-common-text-link': conf?.link }"
      :style="getSpanStyle()"
    >{{ value }}</span>
  </div>
</template>
<script>
export default {
  props: {
    mode: [Boolean, String],
    value: String,
    changeKey: String,
    sendData: [Array, Object, String],
    isSingle: Boolean,
    conf: Object
  },
  data () {
    return {
      highlight: false
    }
  },
  methods: {
    getSpanStyle () {
      const { isGradient, gradientColor } = this.conf?.__config__ || {}
      const { color } = this.conf?.style || {}
      const css = isGradient
        ? {
          backgroundImage: gradientColor,
          color: '#0000',
          'background-clip': 'text',
          '-webkit-background-clip': 'text',
        }
        : {
          color
        }
      return css
    },
    handleEditEmit (event) {
      this.highlight = false
      const relValue = event.target.innerText
      this.$emit('input', relValue)
      const data = this.isSingle ? relValue : this.sendData
      this.$emit('AddFastSiteEdit', {
        key: this.changeKey,
        data,
        fresh: !this.isSingle
      })
    },
    openLink () {
      if (this.conf?.link) {
        window.open(this.conf.link, '_blank')
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.cms-common-edit-input {
  &:focus-visible {
    outline: 0;
  }
}

.input-hight {
  background: #3370ff;
  color: white;
  transition: background 0.3s ease;
}

.cms-common-text-link {
  cursor: pointer;
}
</style>